import { render, staticRenderFns } from "./total-car-cost-calculator.vue?vue&type=template&id=2167bb8b&scoped=true"
import script from "./total-car-cost-calculator.vue?vue&type=script&lang=js"
export * from "./total-car-cost-calculator.vue?vue&type=script&lang=js"
import style0 from "./total-car-cost-calculator.vue?vue&type=style&index=0&id=2167bb8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2167bb8b",
  null
  
)

export default component.exports